module.exports = __webpack_public_path__ + "img/statistics_card.00a0ec94.png";